import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type BulkBillDlnsPayload, type BulkBillDlnsResponse } from './types';
import {
  zodBulkBillDlnsEndpointSchema,
  zodBulkBillDlnsPayloadSchema,
  zodSuccessResponseSchema,
} from './validations';

/**
 * Bulk-bills delivery notes.
 *
 * @param payload - The delivery notes to bill.
 * @param options - Optional request options (e.g. abort signal).
 * @returns The API success response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Delivery-Note/operation/bulk_bill_dlns_delivery_note_bulk_bill_put
 */
export const bulkBillDlns = async (
  payload: BulkBillDlnsPayload,
  options?: KyRequestOptions,
): Promise<BulkBillDlnsResponse> => {
  const response = await vestigasApi
    .put(ENDPOINT.DELIVERY_NOTE.BULK_BILL_DLNS(), {
      json: payload,
      validate: {
        body: zodBulkBillDlnsPayloadSchema,
        pathSegments: zodBulkBillDlnsEndpointSchema,
      },
      ...options,
    })
    .json<BulkBillDlnsResponse>();

  return zodSuccessResponseSchema.parse(response);
};
